import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Loading } from '../../../shared/components/Loading';
import * as authClient from '../clients/auth.client';
import { loadAfterLogin } from '../thunks/load-after-login.thunk';
import * as ecgCountActions from '../../ecg/actions/ecg-count.actions';
import { redirectToLoginPortal } from '../utils/login.util';

export const Login: React.FC = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    let cancelled = false;

    (async () => {
      const user = await authClient.checkStatus();
      if (cancelled) {
        return;
      }

      if (!user) {
        redirectToLoginPortal();
      } else if (user.interface !== 'platane') {
        redirectToLoginPortal(window.location, false);
      } else {
        dispatch(ecgCountActions.reset());
        await dispatch(loadAfterLogin(user));
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [dispatch]);

  return <Loading>Loading user data...</Loading>;
};
